<template>
  <div>
    <Pos_product_list/>
  </div>
</template>

<script>
import Pos_product_list from "@/components/adminArin/pos_system/product/Pos_product_list";
export default {
  name: "PosProductList",
  components: {
    Pos_product_list
  }
}
</script>

<style scoped>

</style>
